import { Locale, ReviewsSortingOption } from '@headless-workspace/config';
import { RatingsAndReviewsDTO } from './RatingsAndReviewsDTO';
import { mapReview, ProductReview } from './types';

export type ReviewSortOption = {
    value: string;
    label: string;
    tag: ReviewsSortingOption;
};

export type RatingFilterData = {
    ratingValue: number;
    reviewsCountPerRating: number;
    progressValue: number;
};

export type RatingsAndReviewsValue = {
    reviewCount: number;
    ratingFilter: RatingFilterData[];
    sortingOptions: ReviewSortOption[];
    reviews: ProductReview[];
};

export type RatingsAndReviewsValueWithDTOSortingOptions = Omit<RatingsAndReviewsValue, 'sortingOptions'> & {
    sortingOptions: { id: string; label: string }[];
};

export const mapRatingFilter = (
    ratingFilter: RatingsAndReviewsDTO['distribution'],
    count: number,
): RatingFilterData[] => {
    return [5, 4, 3, 2, 1].map((rating) => {
        const found = ratingFilter.find((item) => item.rating === rating);
        const reviewsCountPerRating = found?.count ?? 0;

        return {
            ratingValue: rating,
            reviewsCountPerRating,
            progressValue: count > 0 ? (reviewsCountPerRating / count) * 100 : 0,
        };
    });
};

export const mapRatingsAndReviewsValueWithDTOSortingOptions = (
    dto: RatingsAndReviewsDTO,
    locale: Locale,
): RatingsAndReviewsValueWithDTOSortingOptions => {
    return {
        reviewCount: dto.count,
        ratingFilter: mapRatingFilter(dto.distribution, dto.count),
        sortingOptions: dto.sorting,
        reviews: dto.reviews.map((review) => mapReview(review, locale)),
    };
};
